import React from 'react'
import ExistingLoginDetails from '../../components/User/ExistingLogin';

const ExistingLogin = () => {
  return (
    <ExistingLoginDetails />
  )
}

export default ExistingLogin;